import { type FunctionComponent } from 'react';
import { type ButtonSize } from '../button.types';
import { StyledButton, type StyledButtonProps } from '../styled-button/styled-button.component';

/**
 * RebateButton takes all props styled button does except `className` and narrows
 * the `size` prop to not accept null.  This is to reduce inconsistency.
 */
export type RebateButtonProps = {
	size?: NonNullable<Extract<ButtonSize, 'DEFAULT' | 'SMALL' | 'LARGE'>>;
} & Omit<StyledButtonProps, 'className' | 'size'>;

export const RebateButton: FunctionComponent<RebateButtonProps> = (props) => <StyledButton {...props} />;
